const toggledProducts = new Set();

const applyLockedMode = (root = document) => {
  for (const wrapper of root.querySelectorAll('condition-switcher')) {
    const productId = wrapper.dataset.productId;
    if (productId && toggledProducts.has(productId)) {
      wrapper.dataset.mode = 'dropdown';
    }
  }
};

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const trigger = target.closest('[data-condition-switch-trigger]');
  if (!trigger) return;

  const wrapper = trigger.closest('condition-switcher');
  if (!wrapper) return;

  const targetValue = trigger.getAttribute('data-target-value');
  const select = wrapper.querySelector('select');

  if (select && targetValue) {
    select.value = targetValue;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  const productId = wrapper.dataset.productId;
  if (productId) toggledProducts.add(productId);

  wrapper.dataset.mode = 'dropdown';
});

document.addEventListener('variant:update', () => {
  applyLockedMode();
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => applyLockedMode());
} else {
  applyLockedMode();
}
